import { render, staticRenderFns } from "./FrenchWindowDescription.vue?vue&type=template&id=154893e6&scoped=true"
import script from "./FrenchWindowDescription.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowDescription.vue?vue&type=script&lang=ts"
import style0 from "./FrenchWindowDescription.vue?vue&type=style&index=0&id=154893e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154893e6",
  null
  
)

export default component.exports